import { Handle, Position } from "@xyflow/react";
import MaterialIcon from "../../../../components/BuilderComponents/MaterialIcon";
import { getJobTemplateIcon } from "../../../../utils/getMaterialJobIcons";
import "./ActivityFlow.css";

const categoryColors = {
  "Activity Management": "#fa8e36ff",
  Workflow: "#9C27B0",
  Communication: "#34A853",
  "Pro Code": "#eb4c4cff",
  BYODb: "#00ACC1",
  other: "#d61b9eff",
  Documents: "#dadd17ff",
  Invoice: "#C62828",
  Entity: "#3718e9ff",
  "Owner Management": "#7CB342",
  "Data Management": "#5E35B1",
  Navigation: "#00897B",
  AI: "#6A1B9A",
  Utility: "#0097A7",
  Custom: "#f511d6ff",
  default: "#5f6368"
};

const CustomJobNode = ({ data, selected }) => {
  const categoryColor = categoryColors[data.category] || categoryColors.default;
  const iconName = data.icon || getJobTemplateIcon(data.jobTemplate);

  return (
    <div className={`custom_job_node ${selected ? "selected" : ""}`}>
      <Handle
        type="target"
        position={Position.Left}
        style={{ background: categoryColor }}
        className="custom_handle_left"
      />

      <div className="custom_job_node_content">
        <div className="custom_job_node_icon" style={{ color: categoryColor }}>
          <MaterialIcon name={iconName} style={{ fontSize: "40px", fontWeight: "500" }} />
        </div>
      </div>
      <div className="custom_job_node_label">{data.label}</div>
      <Handle
        type="source"
        position={Position.Right}
        style={{ background: categoryColor }}
        className="custom_handle_right"
      />
    </div>
  );
};

export default CustomJobNode;
